function initNewsSection() {
  $('.news-section').each(function(i,e,a) {
    $(this).find('.blog-entry').each(function(i,e,a) {
      $(this).find('.link-more, .link-less, .img-link-more').on('click',function(e) {
        $(this).parents('.blog-entry').find('.expand').children('a').toggleClass('hidden');
      });
    });
  });
}
